// Docs: IMPLEMENTATION.md §3.1 (routing) / §3.3.
// Where lessons open and where new ones are made — one place, so every caller
// (Heute, the ▶ button, the word list, the creator) builds the same URLs.
//
//   /practice/:lessonId           the lesson runner (focus mode)
//   /practice/:lessonId?view=woerter   …opened on the lesson's word overview
//   /?erstellen[=<type>]          Heute with the Erstellen window open

export const CREATOR_PARAM = 'erstellen';

const lessonIdOf = (lesson) => lesson?.id || lesson?.lesson_id || null;

export const lessonPath = (lessonId, { view } = {}) =>
  `/practice/${encodeURIComponent(lessonId)}${view ? `?view=${view}` : ''}`;

// Open a lesson in the runner. The lesson object rides along as router state
// so the runner can skip refetching it; the URL alone is enough to resume it
// after a reload.
export const openLesson = (navigate, lesson, { replace = false, view } = {}) => {
  const id = lessonIdOf(lesson);
  if (!id) return;
  navigate(lessonPath(id, { view }), {
    replace,
    state: { currentLesson: { ...lesson, id } },
  });
};

// Heute with the Erstellen window open, optionally on a type's settings.
export const creatorPath = (type = null) =>
  `/?${CREATOR_PARAM}${type ? `=${encodeURIComponent(type)}` : ''}`;
